import apiClient, { clearTokens, setTokens } from '../client';
import { LoginRequest, LoginResponse, RegisterRequest, User } from '../types';

export const authApi = {
  /**
   * Precheck — ta sama heurystyka co POST /auth/login/ (login_risk_context),
   * bez wysyłania hasła. Pozwala pokazać Turnstile przed pierwszym loginem.
   */
  loginChallenge: async (data: { email: string }): Promise<{ challenge_required: boolean }> => {
    const response = await apiClient.post<{ challenge_required: boolean }>(
      '/auth/login_challenge/',
      data,
    );
    return response.data;
  },

  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/auth/login/', data);
    setTokens(response.data.access, response.data.refresh);
    return response.data;
  },

  register: async (data: RegisterRequest): Promise<{ message: string; user: User }> => {
    const response = await apiClient.post('/auth/register/', data);
    return response.data;
  },

  logout: async (): Promise<void> => {
    try {
      await apiClient.post('/auth/logout/');
    } finally {
      clearTokens();
    }
  },

  refreshToken: async (refreshToken: string): Promise<{ access: string; refresh?: string }> => {
    const response = await apiClient.post('/auth/refresh/', {
      refresh: refreshToken,
    });
    return response.data;
  },

  requestPasswordReset: async (email: string): Promise<{ message: string }> => {
    const response = await apiClient.post('/auth/password_reset/', { email });
    return response.data;
  },

  confirmPasswordReset: async (data: {
    token: string;
    password: string;
    password_confirm: string;
  }): Promise<{ message: string }> => {
    const response = await apiClient.post('/auth/password_reset_confirm/', data);
    return response.data;
  },
};

export default authApi;
